import { connect } from "react-redux";
import realAcceptInvite from "../auth/AcceptInvite";

import {
  getInvite,
  handleInviteSignUp,
  clearInviteError,
  setLoadingToFalse,
  handleGoogleInviteAccept,
  logOutUser,
  clearSignupValidationErrors
} from "../../redux/auth/sessions/actions";
import { withRouting } from "../shared/withRouting";

const AcceptInvite = connect(
  state => ({
    modals: state.ui.main.modals,
    errMessage: state.auth.sessions.sessionData.errMessage,
    accessToken: state.auth.sessions.sessionData.accessToken,
    inviteError: state.auth.sessions.sessionData.inviteError,
    invite: state.auth.sessions.sessionData.invite,
    team: state.auth.sessions.sessionData.team,
    needsActivation: state.auth.sessions.sessionData.needsActivation,
    codeWasResent: state.auth.sessions.sessionData.codeWasResent,
    hasToken: state.auth.sessions.sessionData.accessToken,
    dataLoading: state.ui.main.loading,
    user: state.auth.sessions.sessionData.user
  }),
  dispatch => ({
    getInvite(inviteSecret) {
      return dispatch(getInvite(inviteSecret));
    },
    handleInviteSignUp(payload, navigate, inviteSecret, callback) {
      return dispatch(handleInviteSignUp(payload, navigate, inviteSecret, callback));
    },
    clearInviteError() {
      return dispatch(clearInviteError());
    },
    setLoadingToFalse() {
      return dispatch(setLoadingToFalse());
    },
    handleGoogleInviteAccept(inviteSecret, replaceAccount) {
      return dispatch(handleGoogleInviteAccept(inviteSecret, replaceAccount));
    },
    logOutUser() {
      return dispatch(logOutUser());
    },
    clearSignupValidationErrors() {
      return dispatch(clearSignupValidationErrors());
    }
  })
)(withRouting(realAcceptInvite));

export default AcceptInvite;
